import { Chain } from 'wagmi';

export const awsChain: Chain = {
  id: 1337,
  network: 'aws-fork',
  name: 'AWS-Fork',
  nativeCurrency: {
    decimals: 18,
    name: 'Ethereum',
    symbol: 'ETH',
  },
  rpcUrls: {
    public: { http: ['http://ec2-54-211-119-50.compute-1.amazonaws.com:8545'] },
    default: { http: ['http://ec2-54-211-119-50.compute-1.amazonaws.com:8545'] },
  },
};

export const mixpanelId: string = '4e939c69ff593ebb8c673f11e18e7a9e';
export const fullstoryId: string = 'o-1BYA27-na1';
